import {Pipe, PipeTransform} from "@angular/core";
import {AvBemerkungVersionDetailEntry} from "../../../core/av-api";

@Pipe({
  name: 'avbemerkungArt'
})
export class AvbemerkungArtPipe implements PipeTransform {

  transform(version: AvBemerkungVersionDetailEntry): string {
    if (version.art === AvBemerkungVersionDetailEntry.ArtEnum.ANDERE && version.andereArt != null) {
      return version.andereArt;
    } else {
      return version.art;
    }
  }
}
